import { render, staticRenderFns } from "./TaskLogs.vue?vue&type=template&id=4a866814&scoped=true"
import script from "./TaskLogs.vue?vue&type=script&lang=js"
export * from "./TaskLogs.vue?vue&type=script&lang=js"
import style0 from "./TaskLogs.vue?vue&type=style&index=0&id=4a866814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a866814",
  null
  
)

export default component.exports